<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="container">
        <div class="footer-grid">
          <!-- About Us Section -->
          <div class="footer-section">
            <h3 class="footer-title">ABOUT US</h3>
            <a href="/" class="footer-logo">
              <img src="@/assets/Pulse.png" alt="Pulse Creative Solutions" class="footer-logo-img">
            </a>
          </div>

          <!-- Products Section -->
          <div class="footer-section">
            <h3 class="footer-title">PRODUCTS</h3>
            <ul class="footer-links">
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/careers">Careers</router-link></li>
            </ul>
          </div>

          <!-- Latest News Section -->
          <div class="footer-section">
            <h3 class="footer-title">LATEST NEWS</h3>
            <ul class="footer-links">
              <li><a href="#">Company news</a></li>
              <li><a href="#">Technological innovation</a></li>
            </ul>
          </div>

          <!-- Contact Us Section -->
          <div class="footer-section">
            <h3 class="footer-title">CONTACT US</h3>
            <div class="contact-info">
              <div class="contact-details">
                <p><strong>Email</strong></p>
                <p>admin@pulsecreativesolutions.com</p>
                <p><strong>Landline</strong> <br/>+94 76637 7023</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Copyright Section -->
    <div class="footer-bottom">
      <div class="container">
        <p class="copyright">
          Copyright © 2024 Pulse Creative Solutions All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #6b7c32;
  color: white;
  margin-top: auto;
}

.footer-content {
  padding: 60px 0 40px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  gap: 40px;
  align-items: start;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #e8f5e8;
  text-decoration: underline;
}

/* Logo 样式 */
.footer-logo-img {
  max-height: 120px; /* 调整大小 */
  width: auto;
  display: block;
}

/* Contact Info Styles */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-details p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.contact-details strong {
  color: white;
  font-weight: 600;
}

/* Footer Bottom */
.footer-bottom {
  background-color: #5a6b2a;
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright {
  text-align: center;
  margin: 0;
  font-size: 0.9rem;
  color: #e8f5e8;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }

  .footer-content {
    padding: 40px 0 30px;
  }

  .footer-title {
    font-size: 1.3rem;
  }

  .footer-logo-img {
    max-height: 70px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 480px) {
  .container {
    padding: 0 15px;
  }

  .footer-content {
    padding: 30px 0 20px;
  }

  .footer-grid {
    gap: 25px;
  }

  .footer-title {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }

  .footer-logo-img {
    max-height: 60px;
  }

  .contact-details p {
    font-size: 0.9rem;
  }

  .copyright {
    font-size: 0.8rem;
  }
}
</style>
